import { apiCall } from './gqlClient';

const GETMYCATEGORIES_QUERY = `
  query getMyCategories($providerId: JSON!) {
    getMyCategories(providerId: $providerId)
    {
      id
			name
			counter
			type
			orderIndex
      ...fragments
    }
  }`;

export const getMyCategoriesApiCall = async ({providerId}, fragments = null) => apiCall({ query: GETMYCATEGORIES_QUERY, variables: {providerId}, fragments });

const GETALLCATEGORIES_QUERY = `
  query getAllCategories {
    getAllCategories
    {
      id
			name
			counter
			type
			orderIndex
      ...fragments
    }
  }`;

export const getAllCategoriesApiCall = async (fragments = null) => apiCall({ query: GETALLCATEGORIES_QUERY, variables: {}, fragments });

const GETPROVIDERCATEGORIES_QUERY = `
  query getProviderCategories($providerId: Int, $providerType: String) {
    getProviderCategories(providerId: $providerId, providerType: $providerType)
    {
      id
			name
			counter
			type
			orderIndex
      ...fragments
    }
  }`;

export const getProviderCategoriesApiCall = async ({providerId, providerType}, fragments = null) => apiCall({ query: GETPROVIDERCATEGORIES_QUERY, variables: {providerId, providerType}, fragments });

const GETSERVICECATEGORIES_QUERY = `
  query getServiceCategories($type: String!, $providerId: Int) {
    getServiceCategories(type: $type, providerId: $providerId)
    {
      id
			name
			counter
			type
			orderIndex
      ...fragments
    }
  }`;

export const getServiceCategoriesApiCall = async ({type, providerId}, fragments = null) => apiCall({ query: GETSERVICECATEGORIES_QUERY, variables: {type, providerId}, fragments });

const GETPRODUCTCATEGORIES_QUERY = `
  query getProductCategories($providerId: Int) {
    getProductCategories(providerId: $providerId)
    {
      id
			name
			counter
			type
			orderIndex
      ...fragments
    }
  }`;

export const getProductCategoriesApiCall = async ({providerId}, fragments = null) => apiCall({ query: GETPRODUCTCATEGORIES_QUERY, variables: {providerId}, fragments });
